{"headerInstitutional":"機関投資家向け","headerRetail":"個人投資家向けロードショー","headerDealManager":"ディールマネージャー"}